module.exports = "/assets/inline-meter.png";